import { isDefined as n, isTruthy as c } from "./types3.mjs";
import { ONE_KBYTE as i, EXTENSION_TO_MIME_TYPES_MAP as a } from "./constants26.mjs";
const p = (t, e) => {
  if (n(e) && e.length !== 0) {
    if (c(t.type))
      return e.some((r) => {
        const o = r.toLowerCase(), s = t.type?.toLowerCase();
        if (o === s)
          return !0;
        const u = a[o];
        return u ? u.includes(s) : !1;
      });
    {
      const r = t.name.split(".").pop() || "", o = a[r] || [];
      return e.includes(r) || e.some((s) => o.includes(s.toLowerCase()));
    }
  }
  return !0;
}, E = (t, e) => n(e) ? t.size / i / i <= e : !0, f = (t, e) => n(e) ? t.size / i / i >= e : !0, m = (t, e, r) => n(r) ? e + t <= r : !0, T = (t, e) => n(e) ? e(t) : !0;
export {
  T as validateCustom,
  m as validateMaxFilesCount,
  E as validateMaxSize,
  f as validateMinSize,
  p as validateType
};
//# sourceMappingURL=validation.mjs.map
